import { Component, OnInit, AfterViewInit, Inject, OnDestroy } from '@angular/core';
import { ISubscription } from "rxjs/Subscription";
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { APP_CONFIG, AppConfig } from '../config/app.config.module';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Http, Response } from '@angular/http';
import { TopnavService } from '../header/topnav/topnav.service';
import { NavService } from '../header/nav/nav.service';
import { SharedService } from '../common/shared.service';


/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: November 14th 2017
 * 
 * Description: Component class for Footer
 **/
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})

export class FooterComponent implements OnInit, AfterViewInit, OnDestroy {

  footer= [];
  ftsociallink: any[];
  langID: any;
  dataSocialLnk= [];
  tltSocialLnk;
  dataContact= [];
  tltContact;
  dataAccessPage= [];
  tltAccessPage;
  dataNoOfVisitor= [];
  tltNoOfVisitor;
  dataExtLnk= [];
  tltExtLnk;
  dataBottom= [];
  tltBottom;
  dataBottomLnk= [];
  tltBottomLnk;
  copyright=[];
  dateOfUpdate=[];
  private subscriptionLang: ISubscription;
  private subscription: ISubscription;
  loading: boolean = false;

  private subscriptionFontSize: ISubscription;
  public fontSize: any = {
    "sizeS" : "14px",
    "sizeM" : "19px",
    "sizeL" : "23px",
    "no_styles" : "0.9em"
  };

  public myflag: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private sharedService: SharedService, private translate: TranslateService,
    private router: Router, private http: Http,
    @Inject(APP_CONFIG) private config: AppConfig,
    private topnavservice: TopnavService,public navService: NavService) {
    this.lang = translate.currentLang;

    this.subscriptionLang  = translate.onLangChange.subscribe((event: LangChangeEvent) => {

      const myLang = translate.currentLang;

      if (myLang == 'en') {

        translate.get('HOME').subscribe((res: any) => {
          this.lang = 'en';
          this.langID = 1;
          //this.getFooter(this.langID);
        });
      }
      if (myLang == 'ms') {

        translate.get('HOME').subscribe((res: any) => {
          this.lang = 'ms';
          this.langID = 2;
          //this.getFooter(this.langID);
        });
      }

      if(this.topnavservice.flagLang){
        this.subscription = this.getFooter(this.langID);
      }
    });

    this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data)=>{
      this.fontSize = data;
    });

    this.activatedRoute.queryParams.subscribe(params => {
      let lng = params['language'];
      if (lng && lng.toLowerCase() == 'my') {
        this.myflag = {language:"my"};
        //this.translate.setDefaultLang('ms');
        //this.translate.use('ms');
      } else {
        this.myflag = null;
      } 
    });

  }

  lang; // = this.lang;
  showcontact = true;
  showaccess = true;
  showextlinks = true;
  showvisitor = true;

  private footerUrl: string = this.config.urlFooter;

  boolCallback = (result: boolean) : void => {
   this.loading = result;
  }

  ngOnDestroy() {
    this.subscriptionLang.unsubscribe();
    this.subscription.unsubscribe();
    this.subscriptionFontSize.unsubscribe();
  }

  ngOnInit() {

    if(!this.langID){
      this.langID = localStorage.getItem('langID');
    }else{
      this.langID = 1;
    }
    this.subscription = this.getFooter(this.langID);
  }

  ngAfterViewInit() {
    this.sharedService.loadFontSizeData();
  }

  getFooter(lang) {
// if(this.footer.length == 0){
    return this.http.get(this.footerUrl + '?language=' + lang )
    // return this.http.get(this.footerUrl + '-ms.json')
      .map((response: Response) => response.json())
      .subscribe(resSliderData => {
        this.footer = resSliderData['footerResourceList'];
        this.tltContact = this.footer.filter(fdata => fdata.titleCode === 1)[0];
        this.dataContact = this.tltContact.footerContents;
        let dataRemoved = this.dataContact.filter((el) => {
          return el.footerContentSortingOrder !== 4 && el.footerContentSortingOrder !== 5;
        });
        this.dataContact = dataRemoved;
        this.tltAccessPage = this.footer.filter(fdata => fdata.titleCode === 2)[0];
        this.dataAccessPage = this.tltAccessPage.footerContents;
        this.tltNoOfVisitor = this.footer.filter(fdata => fdata.titleCode === 3)[0];
        this.dataNoOfVisitor = this.tltNoOfVisitor.footerContents;

        // this.dataNoOfVisitor[0].footerSubContentValue = parseInt(this.dataNoOfVisitor[0].footerSubContentValue)+100000; // TESTING PURPOSE ONLY 
        // this.dataNoOfVisitor[1].footerSubContentValue = parseInt(this.dataNoOfVisitor[1].footerSubContentValue)+100000; // TESTING PURPOSE ONLY
        // this.dataNoOfVisitor[2].footerSubContentValue = parseInt(this.dataNoOfVisitor[2].footerSubContentValue)+100000; // TESTING PURPOSE ONLY
        
        // this.dataNoOfVisitor[0].footerSubContentValue = this.dataNoOfVisitor[0].footerSubContentValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        // this.dataNoOfVisitor[1].footerSubContentValue = this.dataNoOfVisitor[1].footerSubContentValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        // this.dataNoOfVisitor[2].footerSubContentValue = this.dataNoOfVisitor[2].footerSubContentValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        if(this.dataNoOfVisitor.length > 0){
          this.dataNoOfVisitor[0].footerSubContentValue = this.dataNoOfVisitor[0].footerSubContentValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        if(this.dataNoOfVisitor.length > 1){
        this.dataNoOfVisitor[1].footerSubContentValue = this.dataNoOfVisitor[1].footerSubContentValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        if(this.dataNoOfVisitor.length > 2){
          this.dataNoOfVisitor[2].footerSubContentValue = this.dataNoOfVisitor[2].footerSubContentValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }

        this.tltSocialLnk = this.footer.filter(fdata => fdata.titleCode === 4)[0];
        this.dataSocialLnk = this.tltSocialLnk.footerContents;
        this.tltBottom = this.footer.filter(fdata => fdata.titleCode === 5);
        this.dataBottom =  this.tltBottom[0].footerContents;
        if(this.dataBottom.length > 0){
            this.copyright = this.dataBottom[1];
            this.dateOfUpdate = this.dataBottom[0];
        }else{
            this.copyright = [];
            this.dateOfUpdate = [];
        }
        this.tltBottomLnk = this.footer.filter(fdata => fdata.titleCode === 6)[0];
        this.dataBottomLnk = this.tltBottomLnk.footerContents;
        this.tltExtLnk = this.footer.filter(fdata => fdata.titleCode === 7)[0];
        this.dataExtLnk = this.tltExtLnk.footerContents;
      });
    // }
  }

  formatUrl(footerLink) {
    let newParam = 'language' + '=' + 'my',
      params = '?' + newParam;

    if (footerLink) {
      params = footerLink.replace(new RegExp('([?&])' + 'language' + '[^&]*'), '$1' + newParam);
      if (params === footerLink) {
        if (footerLink.match(/\?/)) {
          params += '&' + newParam;
        } else {
          params += '?' + newParam;
        }
      }
    }
    return params;
  }

  getUrl(ele){
    console.log(ele);
    //if(ele === 'sitemap' || ele === 'statistic' || ele === 'calendar' || ele === 'subscription' || ele === 'feedback' || ele === 'agencydir' || ele == 'onlineservice' || ele =='category/658')
    //  this.navService.loader = false;
    //else
    //  this.navService.loader = true;
    if (ele.startsWith('http') || ele.startsWith('https')) {
      window.open(ele,'_blank');
      return;
    }

    let split_url = ele.split('/');

    if(ele.includes('/')){
      let lastIndex = ele.lastIndexOf('/'),
          firstSet = ele.substr(0, lastIndex),
          secondSet = ele.substr(lastIndex),
          splitSet = secondSet.split('/');
      this.router.navigate(['/'+firstSet, splitSet[1]], { queryParams: this.myflag });
      /*console.log("before content1");
      if(firstSet === 'content'){
        console.log("content");
        console.log("split: "+splitSet[1]);
        console.log("split: "+firstSet);
        //this.navService.triggerContent(splitSet[1], localStorage.getItem('langID'));
        //this.navService.getContentUrl(splitSet[1], localStorage.getItem('langID'));
      } else {
        //this.router.navigate(['/'+firstSet, splitSet[1]], { queryParams: this.myflag });
      }*/
      window.scrollTo(0, 0);

    } else{
      console.log("selain content: ");
      this.router.navigate(['/'+split_url[0]], { queryParams: this.myflag });
      window.scrollTo(0, 0);
    }

  }


  getTheme() {
    return localStorage.getItem('themeColor');
  }

  changeStyle($event){
    // this.color = $event.type == 'mouseover' ? 'yellow' : 'red';
  }

  showFooter(ele) {
    const temp = 'show' + ele;
    this[temp] = !this[temp];
  }

  showMap(latLong) {
    this.router.navigate(['contact']).then(() => {
      this.router.navigate(['contact',latLong], { queryParams: this.myflag });
    });
  }

  onResize(event) {

    if (event.target.innerWidth >= 767) {
      this.showcontact = true;
      this.showaccess = true;
      this.showextlinks = true;
      this.showvisitor = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/footer/footer.component.ts